import { NotationToDecimalValueType } from "@/lib/interfaces and Enums/TYPENotations";
import {
  FRN_CURRENT_COUPON_NOTATION,
  FRN_QUOTED_MARGIN_NOTATION,
  formatFRNBlockValueWithNotation,
} from "./frnBlockFormatter";

interface IFRNBlockCell {
  params: any;
  testId: string;
  isNumeric: boolean;
  notation?: NotationToDecimalValueType;
}

// LQC-2153: display only. Legs table rows are the blocks straight from
// tradeBlockDataStore, so params.value is already the live block value.
const FRNBlockCell = ({
  params,
  testId,
  isNumeric,
  notation,
}: IFRNBlockCell) => {
  const displayValue = formatFRNBlockValueWithNotation(params.value, notation);

  return (
    <div
      data-testid={testId}
      id={testId}
      className={isNumeric ? "justify-center text-center" : undefined}
      style={isNumeric ? { width: "100%" } : undefined}
    >
      {displayValue}
    </div>
  );
};

export const ReferenceIndexCellRenderer = (params: any) => (
  <FRNBlockCell
    params={params}
    testId="ReferenceIndexCellContainer"
    isNumeric={false}
  />
);

export const QuotedMarginCellRenderer = (params: any) => (
  <FRNBlockCell
    params={params}
    testId="QuotedMarginCellContainer"
    isNumeric={true}
    notation={FRN_QUOTED_MARGIN_NOTATION}
  />
);

export const CurrentCouponCellRenderer = (params: any) => (
  <FRNBlockCell
    params={params}
    testId="CurrentCouponCellContainer"
    isNumeric={true}
    notation={FRN_CURRENT_COUPON_NOTATION}
  />
);
